import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import type { JSX } from 'react';

interface EmptyFilterMessageProps {
  text: string | JSX.Element;
}

const StyledTypography = styled(Typography)`
  margin-top: 25px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const EmptyFilterMessage = ({ text }: EmptyFilterMessageProps) => {
  return (
    <StyledTypography data-test="empty-section" variant="body1">
      {text}
    </StyledTypography>
  );
};
